import { Link, useLocation } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";

import { BiSolidCategory } from "react-icons/bi";
import { DataContext } from "../Context/DataContext/DataContext.jsx";
import DataLoading from "../Suspense/Loadings/DataLoading/DataLoading.jsx";
import { FaBorderAll } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import MobileNav from "./MobileNav/MobileNav.jsx";
import SearchProducts from "../ClientSearch/Products/SearchProducts.jsx";
import { TbHomeFilled } from "react-icons/tb";
import logo from "../Assets/Images/Logo/LogoGreen.png";
import { motion } from "framer-motion";

const NavBar = () => {
  const [selectedMenu, setSelectedMenu] = useState("");
  const location = useLocation();
  const { categories, categoriesLoading } = useContext(DataContext);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const subMenuRef = useRef(null);
  const subMenuButtonRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        subMenuRef.current &&
        !subMenuRef.current.contains(event.target) &&
        subMenuButtonRef.current &&
        !subMenuButtonRef.current.contains(event.target)
      ) {
        setShowSubMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // handle selectedMenu
  useEffect(() => {
    const pathname = location.pathname;
    switch (pathname) {
      case "/":
        setSelectedMenu("home");
        break;
      case "/categories":
        setSelectedMenu("categories");
        break;

      case "/contactus":
        setSelectedMenu("contactus");
        break;

      case "/products":
        setSelectedMenu("products");
        break;

      default:
        setSelectedMenu("");
    }
  }, [location.pathname]);

  return (
    <div
      className="flex items-center justify-center w-screen sticky top-0 z-50 border-b-2 
     bg-[#E1D7B7] border-yellow-600"
    >
      {/* start-webview */}
      <div
        className="w-full flex items-center justify-between px-5 
      "
      >
        {/* start-leftSide */}
        <div className="flex items-center justify-center gap-2">
          {/* Start-logo */}
          <div className="flex items-center justify-center md:hidden relative group h-full ">
            <Link
              to="/"
              className={`flex items-center justify-center h-full w-full 
              ease-in-out duration-100 py-[0.35rem] ${
                selectedMenu === "home"
                  ? "-translate-y-1 py-[0.35rem] text-yellow-600"
                  : "group-hover:-translate-y-1 group-hover:py-[0.35rem] text-black group-hover:text-yellow-600"
              }`}
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{
                  type: "spring",
                  damping: 17,
                  stiffness: 400,
                }}
                className="w-11 h-11 rounded-full flex items-center 
                justify-center "
              >
                <img
                  src={logo}
                  alt="logo"
                  className="w-full h-full object-cover object-center"
                />
              </motion.div>
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center translate-y-[1px] ${
                 selectedMenu === "home" ? "w-full" : "group-hover:w-full w-0"
               }`}
            ></span>
          </div>
          {/* End-logo */}
        </div>
        {/* End-leftSide */}
        {/* Start-RightSide */}
        <div
          dir="rtl"
          className="md:flex items-center justify-center gap-2 hidden"
        >
          {/* Start-logo */}
          <div className="flex items-center justify-center relative group h-full ">
            <Link
              to="/"
              className={`flex items-center justify-center h-full w-full 
              ease-in-out duration-100 py-[0.35rem] ${
                selectedMenu === "home"
                  ? "-translate-y-1 py-[0.35rem] text-yellow-600"
                  : "group-hover:-translate-y-1 group-hover:py-[0.35rem] text-black group-hover:text-yellow-600"
              }`}
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{
                  type: "spring",
                  damping: 17,
                  stiffness: 400,
                }}
                className="w-11 h-11 flex items-center justify-center"
              >
                <img
                  src={logo}
                  alt="logo"
                  className="w-full h-full object-cover object-center"
                />
              </motion.div>
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center translate-y-[1px] ${
                 selectedMenu === "home" ? "w-full" : "group-hover:w-full w-0"
               }`}
            ></span>
          </div>
          {/* End-logo */}
          {/* Start-Navigations */}
          {/* Start-home */}
          <div
            className="relative group flex items-center justify-center overflow-hidden 
            h-full "
          >
            <Link
              onClick={() => setSelectedMenu("home")}
              to="/"
              className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${
                selectedMenu === "home"
                  ? "-translate-y-2 py-4 text-yellow-600"
                  : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-600"
              }`}
            >
              <p dir="rtl" className="font-tajawal">
                الرئيسيه
              </p>
              <TbHomeFilled />
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center ${
                 selectedMenu === "home" ? "w-full" : "group-hover:w-full w-0"
               }`}
            ></span>
          </div>
          {/* End-home */}
          {/* Start-categories */}
          <div
            className="relative group flex items-center justify-center h-full 
            "
          >
            <Link
              to="/categories"
              className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${
                selectedMenu === "categories"
                  ? "-translate-y-2 py-4 text-yellow-600"
                  : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-600"
              }`}
            >
              <p dir="rtl" className="font-tajawal">
                التصنيفات
              </p>
              <BiSolidCategory />
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center ${
                 selectedMenu === "categories"
                   ? "w-full"
                   : "group-hover:w-full w-0 "
               }`}
            ></span>
            <div
              className={`flex items-center justify-center h-full m-1 border-r-2 duration-75 ease-in-out
                       ${
                         showSubMenu
                           ? "border-yellow-700 text-yellow-700 -translate-y-2"
                           : "border-white text-black hover:-translate-y-2 hover:text-yellow-600 hover:border-yellow-600"
                       }`}
            >
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                animate={{ rotate: showSubMenu ? 180 : 0 }}
                transition={{
                  duration: 0.2,
                }}
                ref={subMenuButtonRef}
                onClick={() => setShowSubMenu(!showSubMenu)}
                className="flex items-center justify-center w-full h-full p-2"
              >
                <IoIosArrowDown />
              </motion.button>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{
                height: showSubMenu ? "auto" : 0,
                opacity: showSubMenu ? 1 : 0,
              }}
              ref={subMenuRef}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="absolute top-full z-0
               flex flex-col items-center justify-center"
            >
              <div
                className="flex items-center justify-center flex-col  border-2 
                 border-yellow-600 rounded-xl bg-[#E1D7B7] w-[10rem] overflow-hidden"
              >
                {categoriesLoading ? (
                  <div className="flex items-center justify-center w-full h-full">
                    <DataLoading color="bg-yellow-500" />
                  </div>
                ) : (
                  categories.map((category, index) => (
                    <Link
                      key={index}
                      to={`/categories/${category.category}`}
                      className="w-full"
                      onClick={() => setShowSubMenu(false)}
                    >
                      <div
                        className={`overflow-hidden w-full flex items-center justify-center ${
                          index === categories.length - 1
                            ? "border-b-0"
                            : "border-b-2"
                        }`}
                      >
                        <motion.div
                          initial={{ y: 50 }}
                          animate={{
                            y: showSubMenu ? 0 : 50,
                            transition: {
                              delay: index * 0.1,
                              duration: 0.2,
                            },
                          }}
                          tansition={{
                            duration: 0.2,
                          }}
                          className="flex items-center justify-center p-2 text-yellow-600 hover:bg-stone-500
                        w-full hover:text-white text-center"
                        >
                          <p>{category.category}</p>
                        </motion.div>
                      </div>
                    </Link>
                  ))
                )}
              </div>
            </motion.div>
          </div>
          {/* End-categories */}
          {/* start-allproducts */}
          <div
            className="relative group flex items-center justify-center overflow-hidden 
            h-full "
          >
            <Link
              onClick={() => setSelectedMenu("products")}
              to="/products"
              className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${
                selectedMenu === "products"
                  ? "-translate-y-2 py-4 text-yellow-600"
                  : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-600"
              }`}
            >
              <p dir="rtl" className="font-tajawal">
                جميع المنتجات
              </p>
              <FaBorderAll />
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center ${
                 selectedMenu === "products"
                   ? "w-full"
                   : "group-hover:w-full w-0"
               }`}
            ></span>
          </div>
          {/* start-allproducts */}
          {/* Start-contactus */}
          <div className="relative group flex items-center justify-center overflow-hidden h-full ">
            <Link
              to="/contactus"
              className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${
                selectedMenu === "contactus"
                  ? "-translate-y-2 py-4 text-yellow-500"
                  : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-600"
              }`}
            >
              <p dir="rtl" className="font-tajawal">
                تواصل معنا
              </p>
              <IoCall />
            </Link>
            <span
              className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-600
               duration-100 flex items-center justify-center ${
                 selectedMenu === "contactus"
                   ? "w-full"
                   : "group-hover:w-full w-0 "
               }`}
            ></span>
          </div>
          {/* End-contactus */}
          {/* End-Navigations */}
          {/* Start-Search */}
          <div>
            <SearchProducts />
          </div>
          {/* End-Search */}
        </div>
        {/* End-RightSide */}
        {/* Start-MobileNav */}
        <MobileNav
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
        />
        {/* End-MobileNav */}
      </div>
      {/* End-webView */}
    </div>
  );
};

export default NavBar;
